import type { MessageKey } from "../i18n/messages";

/** What a sale needs from the shop next, as its button: confirm the payment, hand it over, answer, or just look. */
export function sellerNextStep(o: { status: string; buyerMarkedPaid: boolean; unread: boolean }): MessageKey {
  if (o.status === "pending_payment" && o.buyerMarkedPaid) return "home.next.confirm";
  if (o.status === "paid" || o.status === "confirmed") return "home.next.deliver";
  return o.unread ? "home.next.reply" : "home.next.view";
}
